import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBoxGhostLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M14 1.5a4 4 0 0 0-4 0L3.907 5.018a4 4 0 0 0-2 3.464v7.036a4 4 0 0 0 2 3.464L10 22.5a4 4 0 0 0 4 0l6.093-3.518a4 4 0 0 0 2-3.464V8.482a4 4 0 0 0-2-3.464zm-3 1.732a2 2 0 0 1 2 0l6.093 3.518L12 10.845 4.907 6.75zm-7.093 5.25v7.036a2 2 0 0 0 1 1.732L11 20.768v-8.19zM13 20.768l6.093-3.518a2 2 0 0 0 1-1.732V8.482L13 12.577z'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      d='M15.763 12.444V9.827L6.95 4.738l1.979-1.166 8.835 5.1v3.078c0 .573-.306 1.102-.802 1.387a.8.8 0 0 1-1.198-.694'
      opacity={0.4}
    />
  </svg>
)
const ForwardRef = forwardRef(SvgBoxGhostLine)
export default ForwardRef
